import React, { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../../CONTEXT/AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "./login.css";
import { useNavigate } from "react-router-dom";

function Login() {
  const { setAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const userNameRef = useRef();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    userNameRef.current.focus();
  }, []);

  const handleSubmit = (e) => {
    if (!userName || !password) {
      toast.error("Please enter your credentials!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      e.preventDefault();
      axios
        .post("/api/login", {
          username: userName,
          password,
        })
        .then((response) => {
          const accessToken = response.data.accessToken;
          const id = response.data.results[0].id;
          const firstName = response.data.results[0].first_name;
          const middleName = response.data.results[0].middle_name;
          const lastName = response.data.results[0].last_name;
          const username = response.data.results[0].username;
          const email = response.data.results[0].email;
          const staff = response.data.results[0].staff;
          const role = response.data.results[0].role;
          const subscriberName = response.data.results[0].subscriber_name;
          const status = response.data.results[0].status;
          const digitalLendor = response.data.results[0].digital_lendor;
          const disputeManagement =
            response.data.results[0].isdispute_management;
          const nameLookup = response.data.results[0].isname_lookup;
          const pressureLetter = response.data.results[0].ispressure_letter;
          setAuth({
            accessToken,
            id,
            firstName,
            middleName,
            lastName,
            username,
            email,
            staff,
            role,
            subscriberName,
            status,
            digitalLendor,
            disputeManagement,
            nameLookup,
            pressureLetter,
          });
          setUserName("");
          setPassword("");
          navigate("/");
        })
        .catch((error) => {
          if (error.response?.status === 400) {
            toast.error("invalid Password!", {
              position: toast.POSITION.TOP_CENTER,
            });
          } else if (error.response?.status === 500) {
            toast.error("Invalid Username!", {
              position: toast.POSITION.TOP_CENTER,
            });
          } else {
            console.log(error);
            toast.error("Login Failed!", {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        });
    }
  };

  return (
    <section
      className="h-100 gradient-form"
      style={{ backgroundColor: "#eee" }}
    >
      <div className="container py-5 h-100 zoom-out">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-xl-10">
            <div className="card rounded-3 text-black">
              <div className="row g-0">
                <div className="col-lg-6">
                  <div className="card-body p-md-4 mx-md-3">
                    <div className="text-center">
                      <img
                        src="/images/logo.png"
                        style={{ width: "250px", height: "130px" }}
                        alt="logo"
                      />
                      <p className="mt-4 mb-4 pb-1 head">
                        DISPUTE MANAGEMENT SYSTEM
                      </p>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <p>Please login to your account</p>

                      <div className="form-outline mb-4">
                        <input
                          type="text"
                          id="form2Example11"
                          className="form-control"
                          placeholder="Username"
                          onChange={(e) => setUserName(e.target.value)}
                          value={userName}
                          ref={userNameRef}
                          required
                          style={{ borderColor: "red" }}
                        />
                        {!userName && (
                          <label
                            className="form-label"
                            htmlFor="form2Example11"
                          >
                            Username
                          </label>
                        )}
                      </div>

                      <div className="form-outline mb-4">
                        <input
                          type="password"
                          id="form2Example22"
                          className="form-control"
                          onChange={(e) => setPassword(e.target.value)}
                          value={password}
                          required
                        />
                        {!password && (
                          <label
                            className="form-label"
                            htmlFor="form2Example22"
                          >
                            Password
                          </label>
                        )}
                      </div>

                      <div className="text-center pt-1 mb-5 pb-1">
                        <button
                          className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                          type="button"
                          onClick={handleSubmit}
                        >
                          Log in
                        </button>
                      </div>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
                <div className="col-lg-6 d-flex align-items-center gradient-custom-2">
                  <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                    <h4 className="desc mb-4">
                      CREDIT<span className="desc-info">INFO</span> DISPUTE
                      MANAGEMENT
                    </h4>
                    <p className="desc small mb-0">
                      CDM (Customer Disputes Monitoring & Management) is an
                      application that intends to support the data community,
                      i.e., data providers and regulator to have visibility to
                      disputes, by looking at the significant growth and
                      resolution in number of disputes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
